// extracted by mini-css-extract-plugin
export default {"MainContainer":"WelcomePage_MainContainer__Mz0Gi","Text":"WelcomePage_Text__ZApct","notFound":"WelcomePage_notFound__OuZEz"};